import { render, staticRenderFns } from "./QuizRanking.vue?vue&type=template&id=58d12f74&"
import script from "./QuizRanking.vue?vue&type=script&lang=js&"
export * from "./QuizRanking.vue?vue&type=script&lang=js&"
import style0 from "./QuizRanking.vue?vue&type=style&index=0&id=58d12f74&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports